import { FC, useMemo } from 'react';

export interface ResultData {
  CanCreateProfile: boolean;
  HasPhoneNumber: boolean;
  IsAdmin: boolean;
  IsBlacklisted: boolean;
  IsGraylisted: boolean;
  IsSuperAdmin: boolean;
  ProfileEntryResponse: {
    Username: string;
  };
  // There are additional unlisted keys for this...
}

interface Props {
  result: ResultData;
}

const Result: FC<Props> = ({ result }) => {
  const output = useMemo(() => {
    console.log(result);
    if (!result?.ProfileEntryResponse) return 'User not found!';
    if (result.IsBlacklisted && result.IsGraylisted)
      return `${result.ProfileEntryResponse.Username} is both Graylisted AND Blacklisted :(`;
    if (result.IsBlacklisted)
      return `${result.ProfileEntryResponse.Username} is Blacklisted :(`;
    if (result.IsGraylisted)
      return `${result.ProfileEntryResponse.Username} is Graylisted :/`;
    return `${result.ProfileEntryResponse.Username} is NOT Blacklisted! :)`;
  }, [result]);

  if (!output) return null;

  return (
    <div>
      <br />
      {output}
    </div>
  );
};

export default Result;
